var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.brand)?_c('div',{staticClass:"form"},[_c('Header',{attrs:{"brand":_vm.brand}}),_c('Baner',{attrs:{"brand":_vm.brand}}),_c('Form',{attrs:{"config":{
      months: _vm.getMonths,
      models: _vm.getModelsByBrandId(_vm.brand.id),
      uniqueBrands: _vm.getUniqueBrands,
      modelsByBrandName: _vm.getModelsByBrandName(_vm.form.prefered_brand),
      years: _vm.getYears,
      hours: _vm.getHours,
      localization: _vm.getLocalizationByBrandId(_vm.brand.id),
      localizationByBrandName: _vm.getLocalizationByBrandName(_vm.form.prefered_brand),
    }},on:{"typing":function($event){_vm.form = $event},"submit":function($event){_vm.submit(Object.assign({}, _vm.form,
        {brand_id: _vm.brand.id,
        brand: _vm.form.prefered_brand ? null : '- nie wybrano -'})).then(function (r) {
        if (r.status == 200) {
          _vm.$router.push('/success');
        }
      })}}}),_c('Footer')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }